import React, { useEffect, useState } from "react";
import { Modal } from "../Modal";
import { Form, Input, Space } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { useAuth } from "../../contexts/auth";
import { createNotification } from "../../components";
import { editWorkspace } from "../../services/workspace/api";

export function EditWorkspaceModal({ open, onCancel, onSubmit, data }) {
  const intl = useIntl();
  const [form] = Form.useForm();
  const { UpdateWorkspaces, workspaces } = useAuth();
  const [name, setName] = useState("");
  const [submittable, setSubmittable] = useState(false);

  useEffect(() => {
    if (open && data) {
      form.setFieldsValue({
        name: data.label,
      });
    }
  }, [open, form, data])

  const values = Form.useWatch([], form);

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, values]);


  const submit = () => {
    editWorkspace(data.value, { name }).then((res) => {
      createNotification("success", intl.formatMessage({ id: "modal.workspace.edit.success" }));
      UpdateWorkspaces(res.data.workspaces);
      onSubmit();
      form.resetFields();
    }).catch(() => {
      createNotification("error", intl.formatMessage({ id: "modal.workspace.edit.error" }))
    });
  }

  return (
    <Modal.Root visible={open}>
      <Modal.Header
        onCancelAction={onCancel}
        title={intl.formatMessage({ id: "modal.workspace.edit.title" })}
      />
      <Modal.Content align={"start"}>
        <Space
          direction="vertical"
          size="middle"
          style={{
            display: 'flex',
          }}
        >
          <Form layout="vertical" form={form}>
            <Form.Item
              label="Workspace"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Please input the name!',
                },
                { max: 20 }
              ]}
            >
              <Input
                placeholder={intl.formatMessage({ id: "modal.workspace.edit.placeholder" })}
                required
                name="name"
                onChange={(e) => setName(e.target.value)}
                size="large"
              />
            </Form.Item>
          </Form>
        </Space>
      </Modal.Content>
      <Modal.Actions
        loading={false}
        disabled={!submittable}
        submitText={<FormattedMessage id={"send"} />}
        onSubmitAction={submit}
        onCancelAction={onCancel}
      />
    </Modal.Root>
  );
}
